import React, { useEffect, useRef, useState } from 'react';
import porplaceholder from '../img/newplaceholder.png';
import lanplaceholder from '../img/newlanplace.png';

const LazyDiv = (props) => {
    const [inView, setInView] = useState(false);
    const placeholderRef = useRef();
    useEffect(() => {
        const config = {
            root: null, // avoiding 'root' or setting it to 'null' sets it to default value: viewport
            rootMargin: '0px',
            threshold: 0.1
          };
        const observer = new IntersectionObserver((entries, obs) => {
        for (const entry of entries) {
            if (entry.isIntersecting) {
                setInView(true);
                obs.disconnect();
            }
        }
     
   }, config);
    observer.observe(placeholderRef.current);
    return () => {
        observer.disconnect();
    }
}, []);
return (
    inView ? <div {...props}></div> 
    
    : <div {...props} ref={placeholderRef} style={{backgroundImage:`url(${props.orient==="landscape"?lanplaceholder:porplaceholder})`}} >
        {props.children}
        </div>
)
};
export default LazyDiv;